import React from 'react';

import * as styles from './styles';

export interface AnchorToSectionProps {
  elementId: string;
  children: JSX.Element | JSX.Element[];
  className?: string;
  onClick?: () => void;
}

export const AnchorToSection = ({
  className,
  children,
  elementId,
  onClick,
}: AnchorToSectionProps) => (
  <a className={className} css={styles.anchorToSection} href={`#${elementId}`} onClick={onClick}>
    {children}
  </a>
);
